/**
 * Shared recharts helpers for the NiV telemetry / progress charts.
 * Lives in its own module so NivTelemetryTab and NivProgressSection can both
 * import it without a circular dependency.
 */

/** "2026-08-18" → "18.8" */
export const formatDayKey = (dateKey) => {
  if (!dateKey) return "";
  const parts = String(dateKey).split("-");
  if (parts.length < 3) return dateKey;
  return `${Number(parts[2])}.${Number(parts[1])}`;
};

/** Recharts tooltip, RTL-friendly (same shape as NivDataTab's) */
export const TelemetryTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="ntl-tooltip">
      <div className="ntl-tooltip-label">{label}</div>
      {payload.map((entry) => (
        <div key={entry.dataKey} className="ntl-tooltip-row">
          <span
            className="ntl-tooltip-swatch"
            style={{ background: entry.stroke || entry.fill || entry.color }}
          />
          <span>{entry.name}:</span>
          <strong>{Number(entry.value).toLocaleString("he-IL")}</strong>
        </div>
      ))}
    </div>
  );
};
